<template>
  <div class="d-flex align-items-center h-100">
    <div class="error-container d-flex align-items-center">
      <div style="flex-basis: 60%;">
        <img
          src="/image/static/img/forbidden.png"
          alt=""
          style="width: 100%;height: 100%;"
        />
       
      </div>
      <div style="flex-basis: 40%;">
        <h3 class="msg-title">抱歉！</h3>
        <h4>您没有操作权限。</h4>
        <p>当前账号没有操作权限, 请联系管理员。</p>
        <el-button type="primary" @click="goBack()">返回首页</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    goBack () {
      this.$router.replace('/')
    }
  }
}
</script>
<style scoped>
.error-container {
  max-width: 800px;
  margin: 0 auto;
}
.msg-title {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 700;
  line-height: 40px;
  color: #409eff;
}
h4 {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}
p {
  margin-bottom: 30px;
  font-size: 13px;
  line-height: 21px;
}
</style>
